import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Star } from 'lucide-react';
import { contactInfo, businessInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-brand-navy-dark text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img
                src="/logo-new.png"
                alt="Sparkle Property Care Ltd Logo"
                className="h-14 w-auto brightness-110"
              />
            </div>
            <p className="text-sm text-gray-400 mb-4">
              Professional cleaning, property management, and maintenance services in Winnipeg, Manitoba since October 2025.
            </p>
            <p className="text-xs text-gray-500">
              {businessInfo.fullName}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-brand-gold font-semibold mb-4 text-lg">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm hover:text-brand-gold-light transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 bg-brand-gold rounded-full mr-2 group-hover:w-3 transition-all"></span>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-brand-gold-light transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 bg-brand-gold rounded-full mr-2 group-hover:w-3 transition-all"></span>
                  Services
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-sm hover:text-brand-gold-light transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 bg-brand-gold rounded-full mr-2 group-hover:w-3 transition-all"></span>
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/book" className="text-sm hover:text-brand-gold-light transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 bg-brand-gold rounded-full mr-2 group-hover:w-3 transition-all"></span>
                  Book Appointment
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-brand-gold-light transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 bg-brand-gold rounded-full mr-2 group-hover:w-3 transition-all"></span>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-brand-gold font-semibold mb-4 text-lg">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <Phone className="h-4 w-4 text-brand-gold flex-shrink-0" />
                <a href={`tel:${contactInfo.phone}`} className="text-sm hover:text-brand-gold-light transition-colors">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-4 w-4 text-brand-gold flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="text-sm hover:text-brand-gold-light transition-colors break-all">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 text-brand-gold mt-1 flex-shrink-0" />
                <span className="text-sm">{contactInfo.address}</span>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h3 className="text-brand-gold font-semibold mb-4 text-lg">Availability</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Clock className="h-5 w-5 text-brand-gold mt-1 flex-shrink-0" />
                <div>
                  <p className="text-xl font-bold text-white mb-1">24/7</p>
                  <p className="text-sm text-gray-400">Available 24 Hours a Day</p>
                  <p className="text-sm text-gray-400">7 Days a Week</p>
                  <p className="text-xs text-brand-gold-light mt-2">Emergency Services Available</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Google Review Section */}
        <div className="border-t border-brand-navy mt-10 pt-8">
          <div className="text-center space-y-4">
            <h3 className="text-brand-gold font-semibold text-lg">Love Our Service?</h3>
            <p className="text-gray-400 text-sm">Help us grow by leaving a review on Google!</p>
            <a 
              href={contactInfo.googleReviewLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-brand-gold hover:bg-brand-gold-light text-brand-navy font-semibold px-6 py-3 rounded-lg transition-all duration-300 hover:shadow-xl"
            >
              <Star className="h-5 w-5 fill-current" />
              <span>Leave a Google Review</span>
            </a>
          </div>
        </div>

        <div className="border-t border-brand-navy mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} <span className="text-brand-gold font-semibold">Sparkle Property Care Ltd</span>. All rights reserved.
          </p>
          <p className="text-xs text-gray-500 mt-2">
            Proudly serving Winnipeg, Manitoba since October 2025
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
